import React, { useState } from 'react';
import { Dropdown, message } from 'antd';
import { User, LogOut } from 'lucide-react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearUserData } from '@/reducers/users';
import { toggleLoginModal } from '@/reducers/login-pop';
import down from '@/assets/icons/down.png';
import styles from './UserDropdown.module.scss';

const UserDropdown = ({ userData, isSXNU }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleOutSign = () => {
    dispatch(clearUserData());
    dispatch(toggleLoginModal(false));
    navigate(isSXNU ? '/sxnu' : '/');
    message.info('退出登录');
  };

  if (!userData) return null;

  // Menu Items Logic
  const getMenuItems = () => {
    const items = [];

    items.push({
      label: (
        <div
          className="w-full min-w-[160px] flex items-center gap-2 px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition whitespace-nowrap"
          onClick={() => navigate('/personal-center')}
        >
          <User size={18} />
          个人中心
        </div>
      ),
      key: 'user',
    });
    // Logout Item

    items.push({
      type: 'divider',
    });

    items.push({
      label: (
        <div
          className="w-full min-w-[160px] flex items-center gap-2 px-3 py-2.5 text-sm text-red-600 hover:bg-red-50 transition whitespace-nowrap"
          onClick={handleOutSign}
        >
          <LogOut size={18} />
          退出登录
        </div>
      ),
      key: 'loginOut',
    });

    return items;
  };

  return (
    <Dropdown
      open={openDropdown}
      onOpenChange={setOpenDropdown}
      minOverlayWidthMatchTrigger={false}
      overlayClassName={classNames(
        '[&_.ant-dropdown-menu]:min-w-[160px] [&_.ant-dropdown-menu]:w-max',
        styles.logOutClass,
        {
          [styles.singleItemDropdown]: userData?.authInfo?.vip === 1,
        },
      )}
      menu={{
        items: getMenuItems(),
      }}
      trigger={['click']}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
    >
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full hover:bg-white/15 transition cursor-pointer">
        <div className="w-8 h-8">
          {userData?.headimg ? (
            <img
              src={userData.headimg}
              alt={userData?.real_name || '用户头像'}
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-amber-400 to-orange-500 text-white flex items-center justify-center text-sm font-bold">
              {userData?.real_name?.[0] || 'U'}
            </div>
          )}
        </div>
        <span className="text-sm font-medium text-white">
          {userData?.real_name || '-'}
        </span>
        <img
          src={down}
          width={14}
          draggable={false}
          className={classNames('text-white/70', {
            'rotate-180': openDropdown,
          })}
          alt="Down Arrow"
        />
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
